/**
 * docs/ARCHITECTURE.md §6.7, Phase 9 D4: funnel drop-off telemetry, fired at
 * client transitions and posted fire-and-forget to POST /api/event (never
 * awaited, never blocks the rating flow — see main.ts for the call sites).
 */

export type FunnelEvent = "started" | "card_n" | "abandoned" | "demographics_shown" | "completed" | "rate_more";

export interface FunnelEventPayload {
  event: FunnelEvent;
  session_id: string;
  n?: number;
}

/** Matches the subset of navigator.sendBeacon's signature this module needs —
 * injectable so the call site is testable without a DOM. */
export type BeaconSender = (url: string, data: string) => boolean;

export function sendFunnelEvent(apiBase: string, payload: FunnelEventPayload, send: BeaconSender): void {
  try {
    send(`${apiBase}/api/event`, JSON.stringify(payload));
  } catch {
    // Best-effort telemetry — a beacon failure must never affect the rating flow.
  }
}
